export const CSV_UPLOAD_OPTIONS = [
  {
    label: 'label.UPLOAD_SPREADSHEET',
    value: 'csv',
    supports: ['users']
  },
  {
    label: 'label.MANUAL_CSV',
    value: 'manual',
    supports: ['users']
  }
];
